
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.022 8.69a.669.669 0 100-1.336.669.669 0 000 1.337zm0 1.338a2.006 2.006 0 100-4.011 2.006 2.006 0 000 4.01z","fill":"#0F0F0F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.022 1.337c.37 0 .669.3.669.669v.71a5.35 5.35 0 014.638 4.638h.71a.669.669 0 010 1.337h-.71a5.351 5.351 0 01-4.638 4.638v.71a.669.669 0 01-1.337 0v-.71a5.35 5.35 0 01-4.639-4.638h-.71a.669.669 0 010-1.337h.71a5.35 5.35 0 014.639-4.638v-.71c0-.37.299-.669.668-.669zm0 10.696a4.011 4.011 0 100-8.022 4.011 4.011 0 000 8.022z","fill":"#0F0F0F"}})])
          )
        }
      }
    